import module from './module.js'

import './components/component.js'
import './components/empresas/component.js'
import './components/empresas/empresa/component.js'
import './components/empresas/empresa/config/component.js'
import './components/empresas/empresa/descarga/component.js'
import './components/empresas/empresa/descarga/archivo/component.js'
import './components/launcher/component.js'
import './routes/nominas.informacionfiscal.js'
import './services/NominasInformacionfiscal.js'

export default module.name



// WEBPACK FOOTER //
// ./src/nominas/informacionfiscal/index.js